/* eslint-disable no-case-declarations */
import {
  SET_USER_GUIDE, USER_GUIDE_REQUEST_FAILED, SENDING_USER_GUIDE_REQUEST,
} from '../../types/Types';

/** @type { Object } default state */
const defaultState = {
  ugData: '',
  isUgSending: false,
  ugError: false,
  isUgSuccess: false,
};

/**
* dispatched the user data to the store
* @param  { Object } state  default state
* @param  { Object } action dispacthed action from middleware
*/
export default function getUserGuide(state = defaultState, action = {}) {
  switch (action.type) {
    case SET_USER_GUIDE:
      const data = {};
      data.ugData = action.ugData;
      data.isUgSending = action.isUgSending;
      data.isUgSuccess = action.isUgSuccess;
      data.ugError = action.ugError;
      return { ...state, ...data };

    case SENDING_USER_GUIDE_REQUEST:
      const sendingRequest = {};
      sendingRequest.ugData = action.ugData;
      sendingRequest.isUgSending = action.isUgSending;
      sendingRequest.isUgSuccess = action.isUgSuccess;
      sendingRequest.ugError = action.ugError;
      return { ...state, ...sendingRequest };

    case USER_GUIDE_REQUEST_FAILED:
      const errors = {};
      errors.ugData = action.ugData;
      errors.isUgSending = action.isUgSending;
      errors.isUgSuccess = action.isUgSuccess;
      errors.ugError = action.ugError;
      errors.ugMsg = action.ugMsg;
      return { ...state, ...errors };
    default: return state;
  }
}
